// extracted by mini-css-extract-plugin
export default {"message":"ErrorMessage__message--L1USAD"};